import { Component, ChangeDetectorRef } from '@angular/core';
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';
import { IFilterAngularComp } from 'ag-grid-angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

interface MinCharFilterParams extends IFilterParams {
  isGridLoading?: () => boolean;
}

@Component({
  selector: 'app-min-char-text-filter',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './min-char-text-filter.component.html',
  styleUrls: ['./min-char-text-filter.component.css']
})
export class MinCharTextFilterComponent implements IFilterAngularComp {
  private params!: MinCharFilterParams;
  filterText: string = '';
  minChars: number = 3;
  private checkLoadingInterval: any;

  constructor(private cdr: ChangeDetectorRef) {}

  agInit(params: MinCharFilterParams): void {
    this.params = params;
    
    this.checkLoadingInterval = setInterval(() => {
      this.cdr.detectChanges();
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.checkLoadingInterval) {
      clearInterval(this.checkLoadingInterval);
    }
  }

  isGridLoading(): boolean {
    return this.params.isGridLoading ? this.params.isGridLoading() : false;
  }

  canApply(): boolean {
    return !this.isGridLoading() && (this.filterText.length === 0 || this.filterText.length >= this.minChars);
  }

  isFilterActive(): boolean {
    return this.filterText !== '' && this.filterText.length >= this.minChars;
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    if (!this.isFilterActive()) return true;
    
    const field = this.params.colDef.field;
    const value = field ? params.data[field] : null;
    
    if (!value) return false;
    
    return value.toString().toLowerCase().startsWith(this.filterText.toLowerCase());
  }

  getModel() {
    if (!this.isFilterActive()) return null;
    return { 
      filterType: 'text', 
      type: 'startsWith',
      filter: this.filterText 
    };
  }

  setModel(model: any): void {
    this.filterText = model ? model.filter : '';
  }

  onApply(): void {
    if (this.canApply()) {
      this.params.filterChangedCallback();
      
      if ((this.params as any).hidePopup) {
        (this.params as any).hidePopup();
      }
    }
  }
}